import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { LogoIcon } from './Logo';
import config from '../../config/env';

const Footer = ({ variant = 'full', activeLink = null }) => {
  // Full footer with all columns (for Landing page)
  if (variant === 'full') {
    return (
      <footer className="relative border-t border-white/10 bg-[#0a0a0a]">
        <div className="px-6 md:px-12 lg:px-20 py-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
              <div>
                <div className="flex items-center gap-2 mb-6 text-white">
                  <LogoIcon className="w-8 h-8" />
                  {/* <span className="font-medium">NeoPass</span> */}
                </div>
                <p className="text-white/40 text-sm">
                  AI-powered learning assistant.
                </p>
              </div>
              
              <div>
                <h4 className="text-white/40 text-xs font-mono tracking-widest mb-4">PRODUCT</h4>
                <ul className="space-y-3 text-sm">
                  <li><a href={config.extensionDownloadUrl} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">Download</a></li>
                  <li><Link to="/pricing" className="text-white/60 hover:text-white transition-colors">Pricing</Link></li>
                  <li><a href="#capabilities" className="text-white/60 hover:text-white transition-colors">Features</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-white/40 text-xs font-mono tracking-widest mb-4">LEGAL</h4>
                <ul className="space-y-3 text-sm">
                  <li><Link to="/terms" className="text-white/60 hover:text-white transition-colors">Terms of Service</Link></li>
                  <li><Link to="/refund-policy" className="text-white/60 hover:text-white transition-colors">Refund Policy</Link></li>
                  <li><Link to="/contact" className="text-white/60 hover:text-white transition-colors">Contact Us</Link></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-white/40 text-xs font-mono tracking-widest mb-4">ACCOUNT</h4>
                <ul className="space-y-3 text-sm">
                  <li><Link to="/login" className="text-white/60 hover:text-white transition-colors">Login</Link></li>
                  <li><Link to="/signup" className="text-white/60 hover:text-white transition-colors">Sign Up</Link></li>
                </ul>
              </div>
            </div>
            
            <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
              {/* <p className="text-sm text-white/40">
                © 2026 NeoPass. All rights reserved.
              </p> */}
              <div className="flex items-center gap-6 text-sm text-white/40">
                <span>v{config.extensionVersion}</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  // Dashboard footer with background image
  if (variant === 'dashboard') {
    return (
      <footer 
        className="relative border-t border-white/10"
        style={{
          backgroundImage: 'url(/footer-gradient.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-[#111111]/80" />
        <div className="relative px-6 md:px-12 lg:px-20 py-8">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-accent" />
              <span className="font-medium text-white">NeoPass</span>
            </div>
            <p className="text-sm text-white/40">
              © 2026 NeoPass. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }

  // Simple/compact footer (for other pages)
  return (
    <footer className="relative border-t border-white/10 bg-[#0a0a0a]">
      <div className="px-6 md:px-12 lg:px-20 py-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-white">
            <LogoIcon className="h-5 w-5" />
            <span className="font-medium">NeoPass Learning</span>
          </div>
          <p className="text-sm text-white/40">© 2026 NeoPass Learning. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm text-white/40">
            <Link to="/terms" className={`hover:text-white transition-colors ${activeLink === 'terms' ? 'text-white' : ''}`}>Terms</Link>
            <Link to="/refund-policy" className={`hover:text-white transition-colors ${activeLink === 'refunds' ? 'text-white' : ''}`}>Refunds</Link>
            <Link to="/contact" className={`hover:text-white transition-colors ${activeLink === 'contact' ? 'text-white' : ''}`}>Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
